import { AxiosResponse } from 'axios';
import { put, call, throttle, takeLatest } from 'redux-saga/effects';
import { CartActions, failedPlaceOrder, startEmptyCart } from '../cart/cartActions';
import { EditOrderRequest, GetOrderDetails } from '../cart/cartModels';
import {
  failedGetOrderDetail,
  OrderActions,
  successGetOrderDetail,
  successgetOrders,
  requestgetOrders,
  errorgetOrders,
  requestgetLatestOrders,
  successgetLatestOrders,
  errorgetLatestOrders,
  getActiveOrderSuccess,
  getActiveOrderFailed,
  successUpdateOrder,
  failedUpdateOrder,
  successUpdateOrderTip,
  failedUpdateOrderTip,
  getKDSOrderDetails,
  getCustomerOrdersSuccess,
  getCustomerOrdersFailed,
  getCurrenOrderSuccess,
  getCurrenOrderFailed,
} from './orderActions';
import {
  getOrderDetails,
  getNewOrderDetails,
  getOrders,
  getLatestOrders,
  getActiveOrders,
  updateOrderAPI,
  getKDSOrderDetailAPI,
  getNewKDSOrderDetailAPI,
  updateOrderTipAPI,
  customerOrders,
  currentOrder,
} from './orderAPI';
import {
  GET_ACTIVE_ORDERS_REQUEST,
  GET_CURRENTORDER_REQUEST,
  GET_CUSTOMER_ORDERS_REQUEST,
  GET_KDS_ORDER_DETAIL_REQUEST,
  GET_LATEST_ORDERS_ERROR,
  GET_LATEST_ORDERS_REQUEST,
  GET_ORDERS_REQUEST,
  GET_ORDER_DETAIL_REQUEST,
  UPDATE_ORDER_REQUEST,
  UPDATE_TIP_REQUEST,
} from './orderConstants';
import { LatestOrder, OrderDetail, Orders, UpdateOrderTip } from './orderModels';
import { decryptJson, handleDecrypt } from '../../utils/react-ec-utils';
import { validateAndParseResponse } from '../../utils/hmac-utils';
import { showErrorToast, showErrorToastDesktop } from '../../utils/toastUtils';
import { isOfflineFlagKnown, isUseNewOrderApiEnabled, shouldUseNewOrderApiForReceipt } from '../../config/featureFlags';
const isMobile = window.innerWidth <= 768;
function* getOrderDetailSaga(action: OrderActions): any {
  const storedRestaurant = localStorage.getItem('restaurant');
  const slugFromLocalStorage = storedRestaurant ? JSON.parse(storedRestaurant) : null;

  try {
    const payload = action.payload as GetOrderDetails;
    let response: AxiosResponse;
    if (payload?.forReceipt) {
      // Receipt link: see shouldUseNewOrderApiForReceipt. When the offline API was only a guess
      // (no slug, so the location's flag is unknown) and it fails, try the legacy API.
      const guessed = !isOfflineFlagKnown();
      const useNew = shouldUseNewOrderApiForReceipt();
      try {
        response = yield call(useNew ? getNewOrderDetails : getOrderDetails, payload);
        if (useNew && guessed && response?.status !== 200) {
          response = yield call(getOrderDetails, payload);
        }
      } catch (e) {
        if (!(useNew && guessed)) throw e;
        response = yield call(getOrderDetails, payload);
      }
    } else {
      response = yield call(
        isUseNewOrderApiEnabled() ? getNewOrderDetails : getOrderDetails,
        payload
      );
    }

    if (response.status === 200) {
       const data = decryptJson(response.data.encryptedText)
      // const data = response.data.data;
      yield put(successGetOrderDetail(data as OrderDetail));
      if (slugFromLocalStorage && !action?.payload?.donNotEmptyCart) {
        yield put(
          startEmptyCart({
            menuType: slugFromLocalStorage?.menuType,
            restaurantSlug: slugFromLocalStorage?.location,
            clearCartItems: true,
            merchantType: '',
          })
        );
      }
    } else {
      yield put(failedGetOrderDetail());
    }
  } catch (err) {
    yield put(failedGetOrderDetail());
  }
}

function* getCustomerOrderOrderSaga(action: OrderActions): any {
  try {
    const response: AxiosResponse = yield call(customerOrders, action.payload);
    if (!isUseNewOrderApiEnabled()) {
      const parsedResponse = yield call(validateAndParseResponse, response.data);
      if (!parsedResponse?.valid) {
        if (isMobile) {
          showErrorToast(parsedResponse?.message || 'Failed to update profile, Please try Again');
        } else {
          showErrorToastDesktop(
            parsedResponse?.message || 'Failed to update profile, Please try Again'
          );
        }
        return;
      }
    }
    if (response.status === 200) {
      // const decryptedData = decryptJson(response.data.encryptedText);
      yield put(getCustomerOrdersSuccess(response.data.data as any));
    }
  } catch (err) {
    yield put(getCustomerOrdersFailed(err));
  }
}

function* getCurrentOrderData(action: OrderActions) {
  try {
    const response: AxiosResponse = yield call(currentOrder, action.payload);
    if (response.status === 200) {
      // const decryptedData = decryptJson(response.data.encryptedText);

      yield put(getCurrenOrderSuccess(response.data as any));
    }
  } catch (err) {
    yield put(getCurrenOrderFailed(err));
  }
}
function* getKDSOrderDetailSaga(action: OrderActions): any {
  let parsedResponse;
  try {
    const kdsPayload = action.payload as any;
    let response: AxiosResponse;
    // Receipt link without a slug: the offline API is a guess; fall back to the legacy API on failure.
    const guessedOffline = Boolean(kdsPayload?.forReceipt) && !isOfflineFlagKnown() && shouldUseNewOrderApiForReceipt();
    try {
      response = yield call(getKDSOrderDetailAPI, kdsPayload);
      if (guessedOffline && response?.status !== 200) {
        response = yield call(getKDSOrderDetailAPI, kdsPayload, true);
      }
    } catch (e) {
      if (!guessedOffline) throw e;
      response = yield call(getKDSOrderDetailAPI, kdsPayload, true);
    }
    // parsedResponse = yield call(validateAndParseResponse, response.data);
    // if (!parsedResponse?.valid) {
    //   if (isMobile) {
    //     showErrorToast(parsedResponse?.message || 'Failed to update profile, Please try Again');
    //   } else {
    //     showErrorToastDesktop(
    //       parsedResponse?.message || 'Failed to update profile, Please try Again'
    //     );
    //   }
    //   return;
    // }

    if (response.status === 200) {
       const decryptedData = decryptJson(response.data.encryptedText)
      // const decryptedData = response.data.data;
      yield put(successGetOrderDetail(decryptedData as OrderDetail));
    } else {
      yield put(failedGetOrderDetail());
    }
  } catch (err) {
    yield put(failedGetOrderDetail());
  }
}

function* getOrdersSaga(action: OrderActions) {
  try {
    const response: AxiosResponse = yield call(getOrders, action.payload as string);
    if (response.status === 200) {
      yield put(successgetOrders(response.data as Orders));
    }
  } catch (err) {
    yield put(errorgetOrders());
  }
}

function* latestOrderSaga(action: OrderActions) {
  try {
    const response: AxiosResponse = yield call(getLatestOrders, action.payload as string);
    if (response.status === 200) {
      yield put(successgetLatestOrders(response.data as LatestOrder));
    } else {
      yield put(errorgetLatestOrders());
    }
  } catch (err) {
    yield put(errorgetLatestOrders());
  }
}

function* activeOrderSaga(action: OrderActions) {
  try {
    const response: AxiosResponse = yield call(getActiveOrders, action.payload as string);
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);
      yield put(getActiveOrderSuccess(data as LatestOrder));
    } else {
      yield put(getActiveOrderFailed());
    }
  } catch (err) {
    yield put(getActiveOrderFailed());
  }
}

function* updateOrderSaga(action: any): any {
  try {
    const requestData = action.payload as EditOrderRequest;
    const cartDetails = requestData.cart;
    const response: AxiosResponse = yield call(updateOrderAPI, cartDetails);
   
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);
      // const data =response.data.data;
      // Update order success
      yield put(successUpdateOrder(data));
    } else {
      // Update order failed
      const data = decryptJson(response.data.encryptedText);
      yield put(failedPlaceOrder(data?.message ? data?.message : 'Please Retry'));
      yield put(failedUpdateOrder());
    }
  } catch (err: any) {
    yield put(
      failedPlaceOrder(err?.response?.data?.message ? err?.response?.data?.message : 'Please Retry')
    );
    yield put(failedUpdateOrder());
  }
}

function* updateOrderTipSaga(action: any): any {
  const requestData = action.payload as UpdateOrderTip;
  const orderId = requestData?.orderId;
  try {
    const response: AxiosResponse = yield call(updateOrderTipAPI, requestData);
    
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);
      // const data =response.data.data
      // Update order success
      yield put(successUpdateOrderTip(data));
      yield put(getKDSOrderDetails(orderId));
      // if ( requestData?.sagaCallBack != null &&typeof requestData?.sagaCallBack === 'function') {
      //   requestData.sagaCallBack(true);
      // }
    } else {
      // Update order failed
      yield put(failedUpdateOrderTip());
      if (requestData?.sagaCallBack != null && typeof requestData?.sagaCallBack === 'function') {
        requestData.sagaCallBack(false);
      }
    }
  } catch (err) {
    if (requestData?.sagaCallBack != null && typeof requestData?.sagaCallBack === 'function') {
      requestData.sagaCallBack(false);
    }
    yield put(failedUpdateOrderTip());
  }
}

export default function* OrderSaga() {
  yield throttle(3000, GET_ORDER_DETAIL_REQUEST, getOrderDetailSaga);
  yield takeLatest(GET_ORDERS_REQUEST, getOrdersSaga);
  yield throttle(3000, GET_LATEST_ORDERS_REQUEST, latestOrderSaga);
  yield throttle(3000, GET_ACTIVE_ORDERS_REQUEST, activeOrderSaga);
  yield throttle(3000, UPDATE_ORDER_REQUEST, updateOrderSaga);
  yield throttle(3000, GET_KDS_ORDER_DETAIL_REQUEST, getKDSOrderDetailSaga);
  yield throttle(3000, UPDATE_TIP_REQUEST, updateOrderTipSaga);
  yield throttle(3000, GET_CUSTOMER_ORDERS_REQUEST, getCustomerOrderOrderSaga);
  yield throttle(3000, GET_CURRENTORDER_REQUEST, getCurrentOrderData);
}
